import { eGENA_CRMs } from "./CRMs";
import { getErrorString } from "./Error";


export const TEILNEHMERKENNUNG_GENERISCH = "generisch";


export class eGENA_Teilnehmerspezifisches {
	public Notrufnummern : string;
	public CRMs : eGENA_CRMs;
	public Teilnehmerkennung : string;
	public TeilnehmerkennungLokalisiert : string;
	public TeilnehmerBezeichnung : string;
	public TeilnehmerOrt : string | undefined;

	public constructor(Notrufnummern : string, CRMs : eGENA_CRMs, Teilnehmerkennung : string, TeilnehmerkennungLokalisiert : string, TeilnehmerBezeichnung : string, TeilnehmerOrt : string | undefined) {
		this.Notrufnummern = Notrufnummern;
		this.CRMs = CRMs;
		this.Teilnehmerkennung = Teilnehmerkennung;
		this.TeilnehmerkennungLokalisiert = TeilnehmerkennungLokalisiert;
		this.TeilnehmerBezeichnung = TeilnehmerBezeichnung;
		this.TeilnehmerOrt = TeilnehmerOrt;
	}


	public static fromObject(object : any) : eGENA_Teilnehmerspezifisches {
		if (!('CRMs' in object))
			throw new Error("Object: " + JSON.stringify(object) + "\nDas Attribut 'CRMs' ist nicht definiert.");
		let CRMs : eGENA_CRMs = eGENA_CRMs.fromJSONobject(object.CRMs);

		if (!('Notrufnummern' in object))
			throw new Error("Object: " + JSON.stringify(object) + "\nDas Attribut 'Notrufnummern' ist nicht definiert.");

		let TeilnehmerBezeichnung : string;
		if (!('TeilnehmerBezeichnung' in object))
			TeilnehmerBezeichnung = "";
		else
			TeilnehmerBezeichnung = object.TeilnehmerBezeichnung;

		let TeilnehmerOrt : string | undefined;
		if (!('TeilnehmerOrt' in object))
			TeilnehmerOrt = undefined;
		else
			TeilnehmerOrt = object.TeilnehmerOrt;

		let Teilnehmerkennung : string;
		if (!('Teilnehmerkennung' in object))
			throw new Error("Object: " + JSON.stringify(object) + "\nDas Attribut 'Teilnehmerkennung' ist nicht definiert.");
		Teilnehmerkennung = object.Teilnehmerkennung;
		let check : string = eGENA_Teilnehmerspezifisches.checkTeilnehmerkennung(Teilnehmerkennung);
		if (check !== "")
			throw new Error("Object: " + JSON.stringify(object) + "\nDas Attribut 'Teilnehmerkennung' ist nicht korrekt: " + check);

		let TeilnehmerkennungLokalisiert : string;
		if (!('TeilnehmerkennungLokalisiert' in object))
			throw new Error("Object: " + JSON.stringify(object) + "\nDas Attribut 'TeilnehmerkennungLokalisiert' ist nicht definiert.");
		TeilnehmerkennungLokalisiert = object.TeilnehmerkennungLokalisiert;

		return new eGENA_Teilnehmerspezifisches(object.Notrufnummern, CRMs, Teilnehmerkennung, TeilnehmerkennungLokalisiert, TeilnehmerBezeichnung, TeilnehmerOrt);
	}

	public static fromJSONstring(json : string) : eGENA_Teilnehmerspezifisches {
		let object : any;
		try {
			object = JSON.parse(json);
		} catch (e) {
			throw new Error("Fehler beim Parsen JSON->eGENA_Teilnehmerspezifisches: " + getErrorString(e) + "\n\nJSON-String = '" + json + "'");
		}

		return eGENA_Teilnehmerspezifisches.fromObject(object);
	}


	public static checkTeilnehmerkennung(teilnehmerkennung : string | undefined) : string {
		if (!teilnehmerkennung)
			return "Keine Teilnehmerkennung";

		if (teilnehmerkennung !== TEILNEHMERKENNUNG_GENERISCH) {
			if (teilnehmerkennung.length != 8) {
				return "Das Format der Teilnehmerkennung '" + teilnehmerkennung +"' ist ungültig. Die Teilnehmerkennung besteht aus genau 8 Ziffern";
			}

			if (! RegExp('^\\d+$').test(teilnehmerkennung)) {
				return "Das Format der Teilnehmerkennung '" + teilnehmerkennung +"' ist ungültig. Die Teilnehmerkennung besteht ausschließlich aus Ziffern";
			}
		}

		// passt
		return "";
	}

}



// WEBPACK FOOTER //
// ./src/visionet/Teilnehmerspezifisches.ts